import React from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import images from '../images';

const AdvertiserHeader = () => {
    const { id } = useParams();
    const location = useLocation();

    // Формируем путь к страницам
    // Если id есть, используем его, иначе пустая строка
    const pathId = id || '';
    // const myFlowsPath = pathId ? `/advertisers/flows/${pathId}` : '/advertisers/flows';
    // const myLeadsPath = pathId ? `/advertisers/leads/${pathId}` : '/advertisers/leads';
    // const profilePath = pathId ? `/advertisers/profile/${pathId}` : '/advertisers/profile';

    const getActivePage = (pathname) => {
        if (pathname.includes('/advertisers/leads')) return '/advertisers/leads';
        if (pathname.includes('/advertisers/flows')) return '/advertisers/flows';
        return '/advertisers/profile' ;
    };

    const activePage = getActivePage(location.pathname);
    return (
        <div className="default-layout-header">
        <div className="default-layout-nav">
            <ul>
                <li>
                    <Link
                        to={`/advertisers/flows/${pathId}`}
                        className={activePage === '/advertisers/flows' ? 'default-layout-link active' : 'default-layout-link'}
                    >
                        <img
                            src={activePage === '/advertisers/flows' ? images.dashboardActive : images.dashboard}
                            alt=""
                            className="nav-icon"
                        />
                        Потоки
                    </Link>
                </li>
                <li>
                    <Link
                        to={`/advertisers/leads/${pathId}`}
                        className={activePage === '/advertisers/leads' ? 'default-layout-link active' : 'default-layout-link'}
                    >
                        <img
                            src={activePage === '/advertisers/leads' ? images.peopleActive : images.people}
                            alt=""
                            className="nav-icon"
                        />
                        Идентификации
                    </Link>
                </li>
                <li>
                    <Link
                        to={`/advertisers/profile/${pathId}`}
                        className={activePage === '/advertisers/profile' ? 'default-layout-link active' : 'default-layout-link'}
                    >
                        <img
                            src={activePage === '/advertisers/profile' ? images.userActive : images.user}
                            alt=""
                            className="nav-icon"
                        />
                        Профиль
                    </Link>
                </li>
            </ul>
        </div>
    </div>
)
};

export default AdvertiserHeader;